import { render, staticRenderFns } from "./SocialValueInfo.vue?vue&type=template&id=60b68ba4&scoped=true&"
import script from "./SocialValueInfo.vue?vue&type=script&lang=js&"
export * from "./SocialValueInfo.vue?vue&type=script&lang=js&"
import style0 from "./SocialValueInfo.vue?vue&type=style&index=0&id=60b68ba4&scoped=true&lang=css&"
import style1 from "./SocialValueInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b68ba4",
  null
  
)

export default component.exports